"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function CautionWarning(_ref) {
  var className = _ref.className,
    fill = _ref.fill,
    kind = _ref.kind,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '100%' : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '100%' : _ref$width,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$onHover = _ref.onHover,
    onHover = _ref$onHover === void 0 ? function () {} : _ref$onHover;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: className,
    onClick: onClick,
    onMouseEnter: onHover,
    onMouseLeave: onHover,
    role: "none"
  }, kind === 'hollow' && /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: height,
    width: width,
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/_react.default.createElement("title", null, "Caution Warning"), /*#__PURE__*/_react.default.createElement("path", {
    d: "M57,61H7c-2.83,0-5.1-1.11-6.22-3s-1-4.5.46-7l25-44.05C27.66,4.43,29.76,3,32,3s4.34,1.43,5.76,3.91L62.79,51c1.42,2.48,1.59,5,.46,7S59.86,61,57,61ZM32,7c-0.77,0-1.6.69-2.29,1.9l-25,44.05c-0.7,1.22-.87,2.31-0.48,3S5.6,57,7,57H57c1.37,0,2.38-.38,2.76-1.05s0.22-1.77-.47-3l-25-44.06C33.6,7.69,32.77,7,32,7Z",
    style: {
      fill: fill
    }
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "32.01",
    cy: "49",
    r: "3",
    style: {
      fill: fill
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M36,23.09a2,2,0,0,0-.06-0.6,4,4,0,0,0-7.87.09A2,2,0,0,0,28,23s0,0.07,0,.11a4,4,0,0,0,.1.86L30,41.25a2,2,0,0,0,4,0l1.92-17.3c0-.06,0-0.12,0-0.18L36,23.25s0,0,0-.06,0,0,0-.05S36,23.1,36,23.09Z",
    style: {
      fill: fill
    }
  })), kind === 'solid' && /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/_react.default.createElement("title", null, "Warning"), /*#__PURE__*/_react.default.createElement("path", {
    d: "M62.8,51l-25-44.06C36.34,4.43,34.24,3,32,3s-4.34,1.43-5.77,3.92L1.2,51c-1.42,2.49-1.59,5-.46,7S4.13,61,7,61H57c2.83,0,5.1-1.11,6.23-3S64.22,53.46,62.8,51ZM32,52a3,3,0,1,1,3-3A3,3,0,0,1,32,52Zm4-28.82s0,0,0,.06l-0.06.51c0,0.06,0,.12,0,0.18L34,41.25a2,2,0,0,1-4,0L28.1,24a4,4,0,0,1-.1-0.86s0-.07,0-0.11a2,2,0,0,1,0-.43,4,4,0,0,1,7.87-.09,2,2,0,0,1,.06.6s0,0,0,0S36,23.17,36,23.18Z",
    style: {
      fill: fill
    }
  })));
}
var _default = exports.default = CautionWarning;